import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../../common/hooks/useAppSelector';
import { selectUser } from '../../../slices/user/userSlice';
import { useParams, useSearchParams } from 'react-router-dom';
import { TemplatePlaceholderRowProps } from '../components/document-content/components/TemplatePlaceholderRow/types';
import { NWClient } from '../../../client/NWClient';
import { AITemplatePlaceholderModel } from '../../../models/ai.template.placeholder.model';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

export const useTemplatePlaceholderRow = ({
  id,
  data,
  documentHTMLId,
}: TemplatePlaceholderRowProps) => {
  const currentUser = useAppSelector(selectUser);
  const { t } = useTranslation();
  const { documentId } = useParams();
  const [params] = useSearchParams();
  const contractGenerated = params.get('contractGenerated');
  const [pendingStatus, setPendingStatus] = useState<boolean>(false);
  const [field, setField] = useState<string>('');
  const [value, setValue] = useState<string>('');
  const [placeholder, setPlaceholder] = useState<string>('');
  const [editMode, setEditMode] = useState<boolean>(false);
  const [placeholderIdValue, setPlaceholderIdValue] = useState<number>(id);
  const [deletePlaceholderMessageVisible, setDeletePlaceholderMessageVisible] =
    useState<boolean>(false);
  const request = () => {
    setPendingStatus(true);
    const data = {
      data: { field, value, placeholder },
      //[contractGenerated ? 'document_contract' : 'document_upload']: documentUploadId,
      document_upload: Number(documentId),
      document_upload_html: documentHTMLId,
      user: currentUser.id,
    };
    if (id) {
      return NWClient.put('document-template-placeholder', id, data, true);
    } else {
      return NWClient.post('document-template-placeholder', data);
    }
  };
  const handleSavePlaceholder = () => {
    if (editMode || !placeholderIdValue) {
      request()
        .then((res: AITemplatePlaceholderModel) => {
          toast.success(
            placeholderIdValue
              ? t('messages.templatePlaceholderUpdated')
              : t('messages.templatePlaceholderCreated')
          );
          setEditMode(false);
          setPlaceholderIdValue(res.id);
        })
        .catch((error) => {
          toast.error(error.message ? error.message : t('messages.errorOccurred'));
        })
        .finally(() => setPendingStatus(false));
    } else {
      setEditMode(true);
    }
  };
  useEffect(() => {
    setField(data.field);
    setValue(data.value);
    setPlaceholder(data.placeholder);
  }, [data]);

  useEffect(() => {
    setPlaceholderIdValue(id);
  }, [id]);
  return {
    field,
    setField,
    value,
    setValue,
    placeholder,
    setPlaceholder,
    editMode,
    setEditMode,
    placeholderIdValue,
    setPlaceholderIdValue,
    deletePlaceholderMessageVisible,
    setDeletePlaceholderMessageVisible,
    pendingStatus,
    setPendingStatus,
    handleSavePlaceholder,
  };
};
